module.exports = __webpack_public_path__ + "img/mgclogo.9315e016.png";